<template>
  <el-table-column
    prop="default_copies"
    label="Alapértelmezett példányszám"
    show-overflow-tooltip
    min-width="250"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.default_copies || '-' }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'default_copies',
  };
</script>
